import PluginContainer from './Plugin.container';

export default PluginContainer;



// WEBPACK FOOTER //
// ./src/app/modules/Plugin/index.js